import { Container, Card } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import articlesData from '../data/articles.json';
import { formatDate } from '../utils/dateFormat';

function ArticleDetail() {
  const { id } = useParams<{ id: string }>();
  const article = articlesData.articles.find(a => a.id === Number(id));

  if (!article) {
    return (
      <Container>
        <h1 className="text-white">Article not found</h1>
        <Link to="/articles" className="btn btn-primary">
          Back to Articles
        </Link>
      </Container>
    );
  }

  return (
    <Container>
      <Link to="/articles" className="btn btn-primary mb-4">
        Back to Articles
      </Link>
      
      <Card className="bg-dark text-white">
        {article.image && (
          <Card.Img 
            variant="top" 
            src={article.image} 
            alt={article.title}
            className="article-detail-image"
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          />
        )}
        <Card.Body>
          <Card.Title className="display-4 mb-3">{article.title}</Card.Title>
          <Card.Subtitle className="mb-4 text-accent">
            Published: {formatDate(article.date)} | Author: {article.author}
          </Card.Subtitle>
          <div className="article-content">
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{article.detail}</ReactMarkdown>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ArticleDetail; 